import React from "react";

const RfqInfoCard = ({
    rfqData,
    totalSelectedQuotationValue = 0,
    remainingBudget = 0,
    previousApprovers = [],
    formatDate,
    onViewFullRfq,
}) => {
    const formatINR = (value = 0, digits = 0) =>
        new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: digits,
        }).format(Number(value) || 0);

    if (!rfqData) return null;

    return (
        <div className="bg-white border border-gray-200 p-4 mb-4 text-xs">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-18 gap-x-4 gap-y-2">

                <div className="col-span-3">
                    <InfoItem label="RFQ No." value={rfqData.rfqId} />
                </div>

                <div className="col-span-5">
                    <InfoItem label="RFQ Status" value={rfqData.status} />
                </div>

                <div className="md:col-span-5">
                    <InfoItem label="RFQ Budget" value={`Rs. ${formatINR(rfqData.rfqBudget)}`} />
                </div>


                <div className="md:col-span-5">
                    <InfoItem
                        label="Created By"
                        value={
                            <>
                                {rfqData.requesterName}
                                {formatDate?.(
                                    rfqData?.createdAt ||
                                    rfqData?.createdOn ||
                                    rfqData?.createdDate
                                ) && (
                                        <span className="text-gray-500 ml-2">
                                            |{" "}
                                            {formatDate(
                                                rfqData?.createdAt ||
                                                rfqData?.createdOn ||
                                                rfqData?.createdDate
                                            )}
                                        </span>
                                    )}
                            </>
                        }
                    />
                </div>

                <div className="md:col-span-3">
                    <InfoItem label="RFQ Type" value={<span className="capitalize">{rfqData.rfqType}</span>} />
                </div>

                <div className="md:col-span-5 flex gap-2">
                    <p className="text-gray-500 text-xs">RFQ Value:</p>

                    <div className="flex gap-2 font-semibold text-gray-900">
                        <span>Rs. {formatINR(totalSelectedQuotationValue)}</span>

                        {rfqData?.rfqBudget > 0 && (<span
                            className={`text-xs font-medium ${remainingBudget < 0 ? "text-red-600" : "text-green-600"
                                }`}
                        >
                            {remainingBudget < 0 ? "▲" : "▼"} Rs. {formatINR(Math.abs(remainingBudget), 2)}
                        </span>)}
                    </div>
                </div>

                <div className="md:col-span-5">
                    <InfoItem label="Project" value={rfqData.projectName} />
                </div>
                <div className="md:col-span-5 flex flex-wrap gap-2">
                    <p className="text-gray-500 text-xs">Approved By:</p>

                    {previousApprovers.length > 0 ? (
                        previousApprovers.map((approver, index) => (
                            <div key={index} className="font-semibold text-gray-900">
                                {approver.name}
                                {formatDate?.(approver.date) && (
                                    <span className="text-gray-500 ml-2 font-normal">
                                        | {formatDate(approver.date)}
                                    </span>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="text-gray-500">None</div>
                    )}
                </div>
            </div>
        </div>
    );
};

const InfoItem = ({ label, value }) => (
    <div className="flex flex-wrap gap-2">
        <p className="text-gray-500 text-xs">{label}:</p>
        <p className="font-semibold text-gray-900 break-words">{value || "—"}</p>
    </div>
);

export default RfqInfoCard;